export interface DeleteDefaultParameterOrderRequest {
  id: string
  revision: number
}

export function DeleteDefaultParameterOrderRequestToJSON(
  value: DeleteDefaultParameterOrderRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
